export default __webpack_public_path__ + "static/about-3-4538e75acacb34f59d88ee1fabf1263d.jpg";